// extracted by mini-css-extract-plugin
module.exports = {"base":"8px","buttonsContainer":"contactButtons_buttonsContainer__zGwCx","iconButton":"contactButtons_iconButton__N3IWd"};